module.exports = __webpack_public_path__ + "img/dcom.6fa8fa70.png";